export default __webpack_public_path__ + "static/media/img_blog04.cffa5e0a.jpg";